import React from "react";

export const VestOverview = () => {
  return (
    <section className="my-12 w-full px-4 md:px-8">
      <div className="w-full max-w-[1350px] mx-auto">
        {/* Header outside the box */}
        <h1 className="text-[58px] font-extrabold text-white leading-[1.2] max-md:text-4xl max-md:leading-snug font-fredoka font-bold mb-4 font-['Baloo_2'] ">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
          </span><br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
            Token Vesting Overview
          </span>
        </h1>

        {/* Box */}
        <div className="flex flex-col w-full items-start p-4 md:p-8 bg-[#242035] rounded-[20px] border-none frame-11">
          {/* Desktop: Table layout | Mobile: Stacked boxes */}
          <div className="hidden md:flex flex-row items-stretch w-full bg-[#2f2a47] p-0 rounded-xl overflow-hidden border border-[#503564]">
            {/* Allocation Column */}
            <div className="flex flex-col w-full md:w-[259px]">
              <div className="flex items-center gap-2.5 px-3 py-4 border-b border-[#503564]">
                <div className="text-white font-bold text-xl font-['Baloo_2']">Allocation</div>
                <img src="https://c.animaapp.com/mcknvs48G5pY0b/img/group-140.png" alt="" className="w-2" />
                <img src="https://c.animaapp.com/mcknvs48G5pY0b/img/group-141.png" alt="" className="w-2" />
              </div>
              {["Presale", "Staking Rewards", "Team & Advisors", "Community & Events", "Liquidity & Reserve"].map((label, idx) => (
                <div key={label} className={`flex h-[68px] items-center px-3 py-4 border-b border-[#503564] ${idx % 2 === 0 ? "bg-[#2a2540]" : "bg-[#3a3350]"}`}>
                  <div className="text-neutral-100 text-lg font-semibold font-['Inter']">{label}</div>
                </div>
              ))}
            </div>

            {/* Percentage Column */}
            <div className="flex flex-col w-full md:w-[152px] border-l border-[#503564]">
              <div className="flex items-center px-3 py-4 border-b border-[#503564]">
                <div className="text-white font-bold text-xl font-['Baloo_2']">Percentage</div>
              </div>
              {["30%", "20%", "10%", "20%", "20%"].map((val, idx) => (
                <div key={val + idx} className={`flex h-[68px] items-center px-3 py-4 border-b border-[#503564] ${idx % 2 === 0 ? "bg-[#2a2540]" : "bg-[#3a3350]"}`}>
                  <div className="text-neutral-100 text-lg font-normal font-['Inter']">{val}</div>
                </div>
              ))}
            </div>

            {/* Vesting Period Column */}
            <div className="flex flex-col flex-1 border-l border-[#503564] w-full">
              <div className="flex items-center px-3 py-4 border-b border-[#503564]">
                <div className="text-white font-bold text-xl font-['Baloo_2']">Vesting Period</div>
              </div>
              {[
                "Immediate",
                "Ongoing",
                "12 months cliff + 12-month linear vesting",
                "6 months vesting",
                "18 months"
              ].map((text, idx) => (
                <div key={text} className={`flex h-[68px] items-center px-3 py-4 border-b border-[#503564] ${idx % 2 === 0 ? "bg-[#2a2540]" : "bg-[#3a3350]"}`}>
                  <p className="text-neutral-100 text-lg font-normal font-['Inter']">{text}</p>
                </div>
              ))}
            </div>

            {/* Unlock Details Column */}
            <div className="flex flex-col w-full md:w-[446px] border-l border-[#503564]">
              <div className="flex items-center px-3 py-4 border-b border-[#503564]">
                <div className="text-white font-bold text-xl font-['Baloo_2']">Unlock Details</div>
              </div>
              {[
                "100% unlocked at TGE (Token Generation Event)",
                "Released based on staking activity",
                "Starts 1 year after TGE",
                "Gradual unlock based on milestones",
                "Released in tranches every 3 months"
              ].map((text, idx) => (
                <div key={text} className={`flex h-[68px] items-center px-3 py-4 border-b border-[#503564] ${idx % 2 === 0 ? "bg-[#2a2540]" : "bg-[#3a3350]"}`}>
                  <p className="text-neutral-100 text-lg font-normal font-['Inter']">{text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile: Each row shown as its own block */}
          <div className="md:hidden w-full space-y-4 mt-4">
            {[
              {
                allocation: "Presale",
                percentage: "30%",
                period: "Immediate",
                unlock: "100% unlocked at TGE (Token Generation Event)"
              },
              {
                allocation: "Staking Rewards",
                percentage: "20%",
                period: "Ongoing",
                unlock: "Released based on staking activity"
              },
              {
                allocation: "Team & Advisors",
                percentage: "10%",
                period: "12 months cliff + 12-month linear vesting",
                unlock: "Starts 1 year after TGE"
              },
              {
                allocation: "Community & Events",
                percentage: "20%",
                period: "6 months vesting",
                unlock: "Gradual unlock based on milestones"
              },
              {
                allocation: "Liquidity & Reserve",
                percentage: "20%",
                period: "18 months",
                unlock: "Released in tranches every 3 months"
              }
            ].map((item, idx) => (
              <div key={idx} className="bg-[#2f2a47] rounded-xl p-4 border border-[#503564] space-y-2">
                <div className="text-white text-lg font-bold font-['Baloo_2']">Allocation</div>
                <div className="text-neutral-100 text-base">{item.allocation}</div>

                <div className="text-white text-lg font-bold font-['Baloo_2'] mt-2">Percentage</div>
                <div className="text-neutral-100 text-base">{item.percentage}</div>

                <div className="text-white text-lg font-bold font-['Baloo_2'] mt-2">Vesting Period</div>
                <div className="text-neutral-100 text-base">{item.period}</div>

                <div className="text-white text-lg font-bold font-['Baloo_2'] mt-2">Unlock Details</div>
                <div className="text-neutral-100 text-base">{item.unlock}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
